@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_712_924_996)
public val Res.string.availability_day_available_mark: StringResource by lazy {
      StringResource("string:availability_day_available_mark", "availability_day_available_mark", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37724, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52512, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32179, 59),
      ))
    }

@delegate:ResourceContentHash(-786_337_931)
public val Res.string.availability_day_unavailable_mark: StringResource by lazy {
      StringResource("string:availability_day_unavailable_mark", "availability_day_unavailable_mark", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37784, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52584, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32239, 65),
      ))
    }

@delegate:ResourceContentHash(-1_005_052_622)
public val Res.string.availability_deadline: StringResource by lazy {
      StringResource("string:availability_deadline", "availability_deadline", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37850, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52662, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32305, 41),
      ))
    }

@delegate:ResourceContentHash(-891_153_682)
public val Res.string.availability_default_message: StringResource by lazy {
      StringResource("string:availability_default_message", "availability_default_message", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37904, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52728, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32347, 92),
      ))
    }

@delegate:ResourceContentHash(1_449_861_567)
public val Res.string.availability_due_date: StringResource by lazy {
      StringResource("string:availability_due_date", "availability_due_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 37997, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52865, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32440, 41),
      ))
    }

@delegate:ResourceContentHash(-399_186_169)
public val Res.string.availability_due_in_days: StringResource by lazy {
      StringResource("string:availability_due_in_days", "availability_due_in_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38097, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52997, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32544, 52),
      ))
    }

@delegate:ResourceContentHash(1_649_245_571)
public val Res.string.availability_due_in_days_full: StringResource by lazy {
      StringResource("string:availability_due_in_days_full", "availability_due_in_days_full", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38035, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 52911, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32482, 61),
      ))
    }

@delegate:ResourceContentHash(-1_008_188_165)
public val Res.string.availability_due_today: StringResource by lazy {
      StringResource("string:availability_due_today", "availability_due_today", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38154, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53078, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32597, 42),
      ))
    }

@delegate:ResourceContentHash(-990_172_665)
public val Res.string.availability_email_also: StringResource by lazy {
      StringResource("string:availability_email_also", "availability_email_also", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38209, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53149, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32640, 59),
      ))
    }

@delegate:ResourceContentHash(403_759_787)
public val Res.string.availability_email_everyone: StringResource by lazy {
      StringResource("string:availability_email_everyone", "availability_email_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38269, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53269, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32700, 51),
      ))
    }

@delegate:ResourceContentHash(-1_851_342_371)
public val Res.string.availability_email_hint: StringResource by lazy {
      StringResource("string:availability_email_hint", "availability_email_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38325, 223),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53317, 375),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32752, 211),
      ))
    }

@delegate:ResourceContentHash(583_698_114)
public val Res.string.availability_email_without_app: StringResource by lazy {
      StringResource("string:availability_email_without_app", "availability_email_without_app", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38549, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53693, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 32964, 74),
      ))
    }

@delegate:ResourceContentHash(821_151_394)
public val Res.string.availability_end_date: StringResource by lazy {
      StringResource("string:availability_end_date", "availability_end_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38620, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53784, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33039, 41),
      ))
    }

@delegate:ResourceContentHash(1_255_054_633)
public val Res.string.availability_exam_period: StringResource by lazy {
      StringResource("string:availability_exam_period", "availability_exam_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38670, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53854, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33081, 48),
      ))
    }

@delegate:ResourceContentHash(-886_305_764)
public val Res.string.availability_fill_button: StringResource by lazy {
      StringResource("string:availability_fill_button", "availability_fill_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38731, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53903, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33130, 56),
      ))
    }

@delegate:ResourceContentHash(-1_636_125_523)
public val Res.string.availability_given_elsewhere: StringResource by lazy {
      StringResource("string:availability_given_elsewhere", "availability_given_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38800, 168),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 53992, 292),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33187, 160),
      ))
    }

@delegate:ResourceContentHash(79_178_660)
public val Res.string.availability_goes_to: StringResource by lazy {
      StringResource("string:availability_goes_to", "availability_goes_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 38969, 104),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 54285, 188),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33348, 112),
      ))
    }

@delegate:ResourceContentHash(848_877_804)
public val Res.string.availability_hours_from: StringResource by lazy {
      StringResource("string:availability_hours_from", "availability_hours_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39074, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 54474, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33461, 39),
      ))
    }

@delegate:ResourceContentHash(660_849_202)
public val Res.string.availability_hours_hint: StringResource by lazy {
      StringResource("string:availability_hours_hint", "availability_hours_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39110, 163),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 54514, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33501, 111),
      ))
    }

@delegate:ResourceContentHash(-1_246_999_657)
public val Res.string.availability_hours_incomplete: StringResource by lazy {
      StringResource("string:availability_hours_incomplete", "availability_hours_incomplete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39274, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 54710, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33613, 113),
      ))
    }

@delegate:ResourceContentHash(1_511_636_791)
public val Res.string.availability_hours_order: StringResource by lazy {
      StringResource("string:availability_hours_order", "availability_hours_order", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39388, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 54888, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33727, 76),
      ))
    }

@delegate:ResourceContentHash(1_952_145_352)
public val Res.string.availability_hours_title: StringResource by lazy {
      StringResource("string:availability_hours_title", "availability_hours_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39461, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 54997, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33804, 56),
      ))
    }

@delegate:ResourceContentHash(1_349_960_520)
public val Res.string.availability_hours_to: StringResource by lazy {
      StringResource("string:availability_hours_to", "availability_hours_to", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39546, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55106, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33861, 33),
      ))
    }

@delegate:ResourceContentHash(328_337_916)
public val Res.string.availability_legend_outside: StringResource by lazy {
      StringResource("string:availability_legend_outside", "availability_legend_outside", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39580, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55144, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33895, 55),
      ))
    }

@delegate:ResourceContentHash(-811_935_978)
public val Res.string.availability_link_already_sent: StringResource by lazy {
      StringResource("string:availability_link_already_sent", "availability_link_already_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39648, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55212, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 33951, 134),
      ))
    }

@delegate:ResourceContentHash(490_642_274)
public val Res.string.availability_link_change: StringResource by lazy {
      StringResource("string:availability_link_change", "availability_link_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39795, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55427, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34086, 56),
      ))
    }

@delegate:ResourceContentHash(155_414_775)
public val Res.string.availability_link_due: StringResource by lazy {
      StringResource("string:availability_link_due", "availability_link_due", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39852, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55504, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34143, 61),
      ))
    }

@delegate:ResourceContentHash(732_404_396)
public val Res.string.availability_link_footer: StringResource by lazy {
      StringResource("string:availability_link_footer", "availability_link_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 39914, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55574, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34205, 100),
      ))
    }

@delegate:ResourceContentHash(241_173_606)
public val Res.string.availability_link_greeting: StringResource by lazy {
      StringResource("string:availability_link_greeting", "availability_link_greeting", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40126, 122),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55898, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34405, 102),
      ))
    }

@delegate:ResourceContentHash(-232_803_796)
public val Res.string.availability_link_greeting_no_name: StringResource by lazy {
      StringResource("string:availability_link_greeting_no_name", "availability_link_greeting_no_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40015, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 55735, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34306, 98),
      ))
    }

@delegate:ResourceContentHash(-1_202_057_955)
public val Res.string.availability_link_hint: StringResource by lazy {
      StringResource("string:availability_link_hint", "availability_link_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40249, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 56081, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34508, 126),
      ))
    }

@delegate:ResourceContentHash(-695_400_399)
public val Res.string.availability_link_invalid_days: StringResource by lazy {
      StringResource("string:availability_link_invalid_days", "availability_link_invalid_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40396, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 56296, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34635, 118),
      ))
    }

@delegate:ResourceContentHash(-1_513_449_207)
public val Res.string.availability_link_invalid_text: StringResource by lazy {
      StringResource("string:availability_link_invalid_text", "availability_link_invalid_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40543, 146),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 56487, 230),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34754, 146),
      ))
    }

@delegate:ResourceContentHash(-2_113_600_542)
public val Res.string.availability_link_invalid_title: StringResource by lazy {
      StringResource("string:availability_link_invalid_title", "availability_link_invalid_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40690, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 56718, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34901, 87),
      ))
    }

@delegate:ResourceContentHash(1_162_870_121)
public val Res.string.availability_link_load_failed: StringResource by lazy {
      StringResource("string:availability_link_load_failed", "availability_link_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40774, 133),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 56870, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 34989, 121),
      ))
    }

@delegate:ResourceContentHash(551_600_443)
public val Res.string.availability_link_locked: StringResource by lazy {
      StringResource("string:availability_link_locked", "availability_link_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 40908, 140),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57064, 204),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35111, 148),
      ))
    }

@delegate:ResourceContentHash(819_793_790)
public val Res.string.availability_link_made_with: StringResource by lazy {
      StringResource("string:availability_link_made_with", "availability_link_made_with", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41049, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57269, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35260, 87),
      ))
    }

@delegate:ResourceContentHash(-474_016_392)
public val Res.string.availability_link_message: StringResource by lazy {
      StringResource("string:availability_link_message", "availability_link_message", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41153, 77),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57381, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35348, 69),
      ))
    }

@delegate:ResourceContentHash(1_499_549_498)
public val Res.string.availability_link_rate_limited: StringResource by lazy {
      StringResource("string:availability_link_rate_limited", "availability_link_rate_limited", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41231, 102),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57491, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35418, 102),
      ))
    }

@delegate:ResourceContentHash(1_380_276_231)
public val Res.string.availability_link_read_only: StringResource by lazy {
      StringResource("string:availability_link_read_only", "availability_link_read_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41334, 135),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57630, 183),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35521, 127),
      ))
    }

@delegate:ResourceContentHash(784_237_510)
public val Res.string.availability_link_send: StringResource by lazy {
      StringResource("string:availability_link_send", "availability_link_send", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41470, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57814, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35649, 54),
      ))
    }

@delegate:ResourceContentHash(-387_502_517)
public val Res.string.availability_link_sent_text: StringResource by lazy {
      StringResource("string:availability_link_sent_text", "availability_link_sent_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41533, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 57901, 243),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35704, 159),
      ))
    }

@delegate:ResourceContentHash(-1_860_437_820)
public val Res.string.availability_link_sent_title: StringResource by lazy {
      StringResource("string:availability_link_sent_title", "availability_link_sent_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41693, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58145, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35864, 64),
      ))
    }

@delegate:ResourceContentHash(-1_265_669_580)
public val Res.string.availability_link_title: StringResource by lazy {
      StringResource("string:availability_link_title", "availability_link_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41762, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58230, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35929, 55),
      ))
    }

@delegate:ResourceContentHash(1_589_955_622)
public val Res.string.availability_message: StringResource by lazy {
      StringResource("string:availability_message", "availability_message", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41826, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58306, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35985, 56),
      ))
    }

@delegate:ResourceContentHash(1_008_478_979)
public val Res.string.availability_modify_button: StringResource by lazy {
      StringResource("string:availability_modify_button", "availability_modify_button", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41891, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58407, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36042, 74),
      ))
    }

@delegate:ResourceContentHash(-809_964_435)
public val Res.string.availability_month: StringResource by lazy {
      StringResource("string:availability_month", "availability_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42289, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58957, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36412, 34),
      ))
    }

@delegate:ResourceContentHash(-538_428_267)
public val Res.string.availability_month_closed: StringResource by lazy {
      StringResource("string:availability_month_closed", "availability_month_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 41974, 97),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58510, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36117, 93),
      ))
    }

@delegate:ResourceContentHash(-1_155_865_180)
public val Res.string.availability_month_no_roster: StringResource by lazy {
      StringResource("string:availability_month_no_roster", "availability_month_no_roster", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42072, 216),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 58640, 316),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36211, 200),
      ))
    }

@delegate:ResourceContentHash(1_959_410_352)
public val Res.string.availability_multi_select_hint: StringResource by lazy {
      StringResource("string:availability_multi_select_hint", "availability_multi_select_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42328, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59000, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36447, 86),
      ))
    }

@delegate:ResourceContentHash(-293_531_166)
public val Res.string.availability_my_availability: StringResource by lazy {
      StringResource("string:availability_my_availability", "availability_my_availability", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42423, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59119, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36534, 56),
      ))
    }

@delegate:ResourceContentHash(-781_625_775)
public val Res.string.availability_no_requests: StringResource by lazy {
      StringResource("string:availability_no_requests", "availability_no_requests", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42488, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59196, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36591, 76),
      ))
    }

@delegate:ResourceContentHash(1_420_523_147)
public val Res.string.availability_nothing_to_copy: StringResource by lazy {
      StringResource("string:availability_nothing_to_copy", "availability_nothing_to_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42565, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59301, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36668, 88),
      ))
    }

@delegate:ResourceContentHash(1_694_663_693)
public val Res.string.availability_overdue: StringResource by lazy {
      StringResource("string:availability_overdue", "availability_overdue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42686, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59478, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36757, 40),
      ))
    }

@delegate:ResourceContentHash(1_157_134_700)
public val Res.string.availability_past_rosters: StringResource by lazy {
      StringResource("string:availability_past_rosters", "availability_past_rosters", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42731, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59539, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36798, 49),
      ))
    }

@delegate:ResourceContentHash(-563_399_165)
public val Res.string.availability_pick_day_hint: StringResource by lazy {
      StringResource("string:availability_pick_day_hint", "availability_pick_day_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42789, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59609, 166),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36848, 106),
      ))
    }

@delegate:ResourceContentHash(1_566_522_726)
public val Res.string.availability_planning_period: StringResource by lazy {
      StringResource("string:availability_planning_period", "availability_planning_period", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42904, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59776, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 36955, 56),
      ))
    }

@delegate:ResourceContentHash(1_577_048_234)
public val Res.string.availability_quick_templates: StringResource by lazy {
      StringResource("string:availability_quick_templates", "availability_quick_templates", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 42965, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59857, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37012, 56),
      ))
    }

@delegate:ResourceContentHash(1_482_325_363)
public val Res.string.availability_request_sent: StringResource by lazy {
      StringResource("string:availability_request_sent", "availability_request_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43026, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 59930, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37069, 69),
      ))
    }

@delegate:ResourceContentHash(-1_782_403_677)
public val Res.string.availability_requested_days: StringResource by lazy {
      StringResource("string:availability_requested_days", "availability_requested_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43108, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60044, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37139, 95),
      ))
    }

@delegate:ResourceContentHash(1_111_343_018)
public val Res.string.availability_roster_suffix: StringResource by lazy {
      StringResource("string:availability_roster_suffix", "availability_roster_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43216, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60192, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37235, 58),
      ))
    }

@delegate:ResourceContentHash(-419_570_093)
public val Res.string.availability_save_changes: StringResource by lazy {
      StringResource("string:availability_save_changes", "availability_save_changes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43275, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60259, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37294, 49),
      ))
    }

@delegate:ResourceContentHash(1_399_118_150)
public val Res.string.availability_select_preferred_shifts: StringResource by lazy {
      StringResource("string:availability_select_preferred_shifts", "availability_select_preferred_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43329, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60329, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37344, 76),
      ))
    }

@delegate:ResourceContentHash(2_093_054_507)
public val Res.string.availability_select_template: StringResource by lazy {
      StringResource("string:availability_select_template", "availability_select_template", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43410, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60422, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37421, 60),
      ))
    }

@delegate:ResourceContentHash(283_736_856)
public val Res.string.availability_select_weeks: StringResource by lazy {
      StringResource("string:availability_select_weeks", "availability_select_weeks", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43471, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60495, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37482, 53),
      ))
    }

@delegate:ResourceContentHash(1_182_345_182)
public val Res.string.availability_selected_days: StringResource by lazy {
      StringResource("string:availability_selected_days", "availability_selected_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43529, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60561, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37536, 62),
      ))
    }

@delegate:ResourceContentHash(251_746_312)
public val Res.string.availability_send: StringResource by lazy {
      StringResource("string:availability_send", "availability_send", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43650, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60706, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37649, 33),
      ))
    }

@delegate:ResourceContentHash(552_742_895)
public val Res.string.availability_send_request: StringResource by lazy {
      StringResource("string:availability_send_request", "availability_send_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43592, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60632, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37599, 49),
      ))
    }

@delegate:ResourceContentHash(1_485_054_704)
public val Res.string.availability_sharing_ask_body: StringResource by lazy {
      StringResource("string:availability_sharing_ask_body", "availability_sharing_ask_body", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 43688, 421),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 60756, 581),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 37683, 325),
      ))
    }

@delegate:ResourceContentHash(2_125_612_592)
public val Res.string.availability_sharing_ask_no: StringResource by lazy {
      StringResource("string:availability_sharing_ask_no", "availability_sharing_ask_no", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44110, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 61338, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38009, 47),
      ))
    }

@delegate:ResourceContentHash(59_060_643)
public val Res.string.availability_sharing_ask_title: StringResource by lazy {
      StringResource("string:availability_sharing_ask_title", "availability_sharing_ask_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44158, 98),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 61394, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38057, 86),
      ))
    }

@delegate:ResourceContentHash(-1_154_805_485)
public val Res.string.availability_sharing_ask_yes: StringResource by lazy {
      StringResource("string:availability_sharing_ask_yes", "availability_sharing_ask_yes", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44257, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 61517, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38144, 56),
      ))
    }

@delegate:ResourceContentHash(250_083_235)
public val Res.string.availability_sharing_desc: StringResource by lazy {
      StringResource("string:availability_sharing_desc", "availability_sharing_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44326, 289),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 61594, 445),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38201, 233),
      ))
    }

@delegate:ResourceContentHash(-1_330_599_581)
public val Res.string.availability_sharing_title: StringResource by lazy {
      StringResource("string:availability_sharing_title", "availability_sharing_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44616, 110),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62040, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38435, 90),
      ))
    }

@delegate:ResourceContentHash(626_485_546)
public val Res.string.availability_slot_all_day: StringResource by lazy {
      StringResource("string:availability_slot_all_day", "availability_slot_all_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44727, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62195, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38526, 45),
      ))
    }

@delegate:ResourceContentHash(-1_546_360_448)
public val Res.string.availability_standard_week: StringResource by lazy {
      StringResource("string:availability_standard_week", "availability_standard_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44777, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62257, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38572, 54),
      ))
    }

@delegate:ResourceContentHash(265_369_679)
public val Res.string.availability_start_date: StringResource by lazy {
      StringResource("string:availability_start_date", "availability_start_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44836, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62336, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38627, 47),
      ))
    }

@delegate:ResourceContentHash(1_826_182_572)
public val Res.string.availability_stats_bar: StringResource by lazy {
      StringResource("string:availability_stats_bar", "availability_stats_bar", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44892, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62400, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38675, 90),
      ))
    }

@delegate:ResourceContentHash(-1_337_275_420)
public val Res.string.availability_status_open: StringResource by lazy {
      StringResource("string:availability_status_open", "availability_status_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 44987, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62543, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38766, 40),
      ))
    }

@delegate:ResourceContentHash(1_101_652_942)
public val Res.string.availability_submit_by: StringResource by lazy {
      StringResource("string:availability_submit_by", "availability_submit_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45032, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62600, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38807, 50),
      ))
    }

@delegate:ResourceContentHash(807_307_215)
public val Res.string.availability_time: StringResource by lazy {
      StringResource("string:availability_time", "availability_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45087, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62663, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38858, 33),
      ))
    }

@delegate:ResourceContentHash(963_710_762)
public val Res.string.availability_unavailable: StringResource by lazy {
      StringResource("string:availability_unavailable", "availability_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45125, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62697, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38892, 48),
      ))
    }

@delegate:ResourceContentHash(-420_095_530)
public val Res.string.availability_week: StringResource by lazy {
      StringResource("string:availability_week", "availability_week", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45174, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62758, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 38941, 61),
      ))
    }

@delegate:ResourceContentHash(-1_086_099_711)
public val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45240, 20),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62832, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39003, 20),
      ))
    }

@delegate:ResourceContentHash(-1_742_933_570)
public val Res.string.break_end: StringResource by lazy {
      StringResource("string:break_end", "break_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45261, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62861, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39024, 29),
      ))
    }

@delegate:ResourceContentHash(514_348_016)
public val Res.string.break_problem_ends_before_start: StringResource by lazy {
      StringResource("string:break_problem_ends_before_start", "break_problem_ends_before_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45303, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 62923, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39054, 83),
      ))
    }

@delegate:ResourceContentHash(80_674_775)
public val Res.string.break_problem_open: StringResource by lazy {
      StringResource("string:break_problem_open", "break_problem_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45403, 114),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63063, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39138, 122),
      ))
    }

@delegate:ResourceContentHash(-1_121_171_357)
public val Res.string.break_problem_outside_shift: StringResource by lazy {
      StringResource("string:break_problem_outside_shift", "break_problem_outside_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45518, 119),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63242, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39261, 91),
      ))
    }

@delegate:ResourceContentHash(-2_146_266_809)
public val Res.string.break_problem_overlap: StringResource by lazy {
      StringResource("string:break_problem_overlap", "break_problem_overlap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45638, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63398, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39353, 61),
      ))
    }

@delegate:ResourceContentHash(1_786_738_599)
public val Res.string.break_problem_too_many: StringResource by lazy {
      StringResource("string:break_problem_too_many", "break_problem_too_many", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45720, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63504, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39415, 82),
      ))
    }

@delegate:ResourceContentHash(1_700_963_843)
public val Res.string.break_problem_unreadable: StringResource by lazy {
      StringResource("string:break_problem_unreadable", "break_problem_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45807, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63639, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39498, 68),
      ))
    }

@delegate:ResourceContentHash(-668_493_280)
public val Res.string.break_start: StringResource by lazy {
      StringResource("string:break_start", "break_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45892, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63756, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39567, 35),
      ))
    }

@delegate:ResourceContentHash(586_915_776)
public val Res.string.bulk_change_from_day: StringResource by lazy {
      StringResource("string:bulk_change_from_day", "bulk_change_from_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45940, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63812, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39603, 52),
      ))
    }

@delegate:ResourceContentHash(-1_791_990_104)
public val Res.string.bulk_change_line: StringResource by lazy {
      StringResource("string:bulk_change_line", "bulk_change_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 45989, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63861, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39656, 52),
      ))
    }

@delegate:ResourceContentHash(-1_130_659_486)
public val Res.string.bulk_clear: StringResource by lazy {
      StringResource("string:bulk_clear", "bulk_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46042, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63914, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39709, 26),
      ))
    }

@delegate:ResourceContentHash(-122_826_999)
public val Res.string.bulk_contract_unchanged: StringResource by lazy {
      StringResource("string:bulk_contract_unchanged", "bulk_contract_unchanged", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46073, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 63957, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39736, 63),
      ))
    }

@delegate:ResourceContentHash(-671_494_457)
public val Res.string.bulk_declared_hours: StringResource by lazy {
      StringResource("string:bulk_declared_hours", "bulk_declared_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46137, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64041, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39800, 87),
      ))
    }

@delegate:ResourceContentHash(-1_534_804_273)
public val Res.string.bulk_edit_done: StringResource by lazy {
      StringResource("string:bulk_edit_done", "bulk_edit_done", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46351, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64363, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40010, 74),
      ))
    }

@delegate:ResourceContentHash(-843_498_066)
public val Res.string.bulk_edit_done_partly: StringResource by lazy {
      StringResource("string:bulk_edit_done_partly", "bulk_edit_done_partly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46233, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64193, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39888, 121),
      ))
    }

@delegate:ResourceContentHash(-1_610_779_943)
public val Res.string.bulk_edit_hint: StringResource by lazy {
      StringResource("string:bulk_edit_hint", "bulk_edit_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46422, 134),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64458, 218),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40085, 134),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString4Resources(map: MutableMap<String, StringResource>) {
  map.put("availability_day_available_mark", Res.string.availability_day_available_mark)
  map.put("availability_day_unavailable_mark", Res.string.availability_day_unavailable_mark)
  map.put("availability_deadline", Res.string.availability_deadline)
  map.put("availability_default_message", Res.string.availability_default_message)
  map.put("availability_due_date", Res.string.availability_due_date)
  map.put("availability_due_in_days", Res.string.availability_due_in_days)
  map.put("availability_due_in_days_full", Res.string.availability_due_in_days_full)
  map.put("availability_due_today", Res.string.availability_due_today)
  map.put("availability_email_also", Res.string.availability_email_also)
  map.put("availability_email_everyone", Res.string.availability_email_everyone)
  map.put("availability_email_hint", Res.string.availability_email_hint)
  map.put("availability_email_without_app", Res.string.availability_email_without_app)
  map.put("availability_end_date", Res.string.availability_end_date)
  map.put("availability_exam_period", Res.string.availability_exam_period)
  map.put("availability_fill_button", Res.string.availability_fill_button)
  map.put("availability_given_elsewhere", Res.string.availability_given_elsewhere)
  map.put("availability_goes_to", Res.string.availability_goes_to)
  map.put("availability_hours_from", Res.string.availability_hours_from)
  map.put("availability_hours_hint", Res.string.availability_hours_hint)
  map.put("availability_hours_incomplete", Res.string.availability_hours_incomplete)
  map.put("availability_hours_order", Res.string.availability_hours_order)
  map.put("availability_hours_title", Res.string.availability_hours_title)
  map.put("availability_hours_to", Res.string.availability_hours_to)
  map.put("availability_legend_outside", Res.string.availability_legend_outside)
  map.put("availability_link_already_sent", Res.string.availability_link_already_sent)
  map.put("availability_link_change", Res.string.availability_link_change)
  map.put("availability_link_due", Res.string.availability_link_due)
  map.put("availability_link_footer", Res.string.availability_link_footer)
  map.put("availability_link_greeting", Res.string.availability_link_greeting)
  map.put("availability_link_greeting_no_name", Res.string.availability_link_greeting_no_name)
  map.put("availability_link_hint", Res.string.availability_link_hint)
  map.put("availability_link_invalid_days", Res.string.availability_link_invalid_days)
  map.put("availability_link_invalid_text", Res.string.availability_link_invalid_text)
  map.put("availability_link_invalid_title", Res.string.availability_link_invalid_title)
  map.put("availability_link_load_failed", Res.string.availability_link_load_failed)
  map.put("availability_link_locked", Res.string.availability_link_locked)
  map.put("availability_link_made_with", Res.string.availability_link_made_with)
  map.put("availability_link_message", Res.string.availability_link_message)
  map.put("availability_link_rate_limited", Res.string.availability_link_rate_limited)
  map.put("availability_link_read_only", Res.string.availability_link_read_only)
  map.put("availability_link_send", Res.string.availability_link_send)
  map.put("availability_link_sent_text", Res.string.availability_link_sent_text)
  map.put("availability_link_sent_title", Res.string.availability_link_sent_title)
  map.put("availability_link_title", Res.string.availability_link_title)
  map.put("availability_message", Res.string.availability_message)
  map.put("availability_modify_button", Res.string.availability_modify_button)
  map.put("availability_month", Res.string.availability_month)
  map.put("availability_month_closed", Res.string.availability_month_closed)
  map.put("availability_month_no_roster", Res.string.availability_month_no_roster)
  map.put("availability_multi_select_hint", Res.string.availability_multi_select_hint)
  map.put("availability_my_availability", Res.string.availability_my_availability)
  map.put("availability_no_requests", Res.string.availability_no_requests)
  map.put("availability_nothing_to_copy", Res.string.availability_nothing_to_copy)
  map.put("availability_overdue", Res.string.availability_overdue)
  map.put("availability_past_rosters", Res.string.availability_past_rosters)
  map.put("availability_pick_day_hint", Res.string.availability_pick_day_hint)
  map.put("availability_planning_period", Res.string.availability_planning_period)
  map.put("availability_quick_templates", Res.string.availability_quick_templates)
  map.put("availability_request_sent", Res.string.availability_request_sent)
  map.put("availability_requested_days", Res.string.availability_requested_days)
  map.put("availability_roster_suffix", Res.string.availability_roster_suffix)
  map.put("availability_save_changes", Res.string.availability_save_changes)
  map.put("availability_select_preferred_shifts", Res.string.availability_select_preferred_shifts)
  map.put("availability_select_template", Res.string.availability_select_template)
  map.put("availability_select_weeks", Res.string.availability_select_weeks)
  map.put("availability_selected_days", Res.string.availability_selected_days)
  map.put("availability_send", Res.string.availability_send)
  map.put("availability_send_request", Res.string.availability_send_request)
  map.put("availability_sharing_ask_body", Res.string.availability_sharing_ask_body)
  map.put("availability_sharing_ask_no", Res.string.availability_sharing_ask_no)
  map.put("availability_sharing_ask_title", Res.string.availability_sharing_ask_title)
  map.put("availability_sharing_ask_yes", Res.string.availability_sharing_ask_yes)
  map.put("availability_sharing_desc", Res.string.availability_sharing_desc)
  map.put("availability_sharing_title", Res.string.availability_sharing_title)
  map.put("availability_slot_all_day", Res.string.availability_slot_all_day)
  map.put("availability_standard_week", Res.string.availability_standard_week)
  map.put("availability_start_date", Res.string.availability_start_date)
  map.put("availability_stats_bar", Res.string.availability_stats_bar)
  map.put("availability_status_open", Res.string.availability_status_open)
  map.put("availability_submit_by", Res.string.availability_submit_by)
  map.put("availability_time", Res.string.availability_time)
  map.put("availability_unavailable", Res.string.availability_unavailable)
  map.put("availability_week", Res.string.availability_week)
  map.put("back", Res.string.back)
  map.put("break_end", Res.string.break_end)
  map.put("break_problem_ends_before_start", Res.string.break_problem_ends_before_start)
  map.put("break_problem_open", Res.string.break_problem_open)
  map.put("break_problem_outside_shift", Res.string.break_problem_outside_shift)
  map.put("break_problem_overlap", Res.string.break_problem_overlap)
  map.put("break_problem_too_many", Res.string.break_problem_too_many)
  map.put("break_problem_unreadable", Res.string.break_problem_unreadable)
  map.put("break_start", Res.string.break_start)
  map.put("bulk_change_from_day", Res.string.bulk_change_from_day)
  map.put("bulk_change_line", Res.string.bulk_change_line)
  map.put("bulk_clear", Res.string.bulk_clear)
  map.put("bulk_contract_unchanged", Res.string.bulk_contract_unchanged)
  map.put("bulk_declared_hours", Res.string.bulk_declared_hours)
  map.put("bulk_edit_done", Res.string.bulk_edit_done)
  map.put("bulk_edit_done_partly", Res.string.bulk_edit_done_partly)
  map.put("bulk_edit_hint", Res.string.bulk_edit_hint)
}
